module.exports = __webpack_public_path__ + "img/wddb-icon.8a6ef166.png";